/**
 * MessageItem component
 * Memoized to prevent re-renders
 */
import React, { memo } from 'react';
import { Box, Text } from 'ink';
import type { ChatMessage } from '../../../types/llm.types.js';

interface MessageItemProps {
    message: ChatMessage;
}

export const MessageItem = memo<MessageItemProps>(({ message }) => {
    if (message.role === 'user') {
        return (
            <Box flexDirection="column" marginBottom={1}>
                <Text color="cyan" bold>You:</Text>
                <Text wrap="wrap">{message.content}</Text>
            </Box>
        );
    }

    if (message.role === 'assistant') {
        return (
            <Box flexDirection="column" marginBottom={1}>
                <Text color="green" bold>Jai1:</Text>
                <Text wrap="wrap">{message.content}</Text>
            </Box>
        );
    }

    return (
        <Box marginBottom={1}>
            <Text dimColor italic>{message.content}</Text>
        </Box>
    );
});
